var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "role": "row"
    }
  }, [_vm.label ? _c('div', {
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._v(_vm._s(_vm.label)), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pointer,
      expression: "pointer"
    }],
    staticClass: "color-red"
  }, [_vm._v("*")])]) : _c('div', {
    attrs: {
      "role": "columnheader"
    }
  }, [_vm._t("title")], 2), _c('div', {
    attrs: {
      "role": "cell"
    }
  }, [_vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }